import { Box, Text } from '@rsos/base-components';
import { useGetSelectedCollaborator } from '@rsos/reduxDataStore/src/features/emergencyCalls/helpers';
import { HeaderContainer, RedCircle } from './CollaboratorChatbox.styles';
import ExpandButton from './ExpandButton';

interface CollaboratorChatHeaderProps {
  isChatBoxVisible: boolean;
  setIsChatBoxVisible?: (isChatBoxVisible: boolean) => void;
}

const CollaboratorChatHeader = ({
  isChatBoxVisible,
  setIsChatBoxVisible,
}: CollaboratorChatHeaderProps) => {
  const collaborator = useGetSelectedCollaborator();

  const handleExpandButtonClicked = () => {
    if (setIsChatBoxVisible) {
      setIsChatBoxVisible(!isChatBoxVisible);
    }
  };

  return (
    <HeaderContainer data-name="conversations-chat-header" pb="16px" pt="12px">
      <Box horizontal justify="space-between" px="12px" width="100%">
        <Box>
          <Text inline fontWeight="bold">
            <Text color="primaryText" size="normal">
              <RedCircle />
              Agency Live Chat
            </Text>
            <Box horizontal>
              <Text color="secondaryText" fontWeight="regular" size="xsmall">
                {collaborator.pairedAccountName}
              </Text>
            </Box>
          </Text>
        </Box>
        <ExpandButton
          isChatBoxVisible={isChatBoxVisible}
          onActionButtonClick={handleExpandButtonClicked}
        />
      </Box>
    </HeaderContainer>
  );
};

export default CollaboratorChatHeader;
